export const mgPlatformArrowUpDownIcon = {
  data: `<svg viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 4.25L12 0.75M12 0.75L15.25 4.25M12 0.75V13.25M7.25 9.75L4 13.25M4 13.25L0.75 9.75M4 13.25V0.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-up-down'
}
